import { ProductDetailViewEvent } from '@/usecases/event-bus-for-third-party/events/product-detail'

/**
 * 旧フォーマット（SKUでなくFKUをアイテムとして採用）のdataLayer.push
 * 移行時に新旧両方をサポートしておくことにしたが、移行が終わればこちらは削除する
 *
 * @see https://github.com/Everforth/growthpalette-front/issues/8606#issuecomment-3797519671
 */
export function handleProductDetailViewEventOld(event: ProductDetailViewEvent): void {
  window.dataLayer.push({
    pageType: 'productDetail',
    event: 'view_item',
    ecommerce: {
      detail: {
        products: event.fku.map(fku => ({
          item_id: fku.id,
          item_name: event.root.name,
          item_variant: fku.color,
          price: fku.price.min,
        })),
      },
    },
  })
}
